<template>
  <BaseFilter
    title="Order Filter"
    @submit="$emit('apply')"
    @reset="$emit('reset')"
    :isChips="isChips"
    newClass="pa-0 ma-0 btn-box background_color primary--text"
    iconSize="15"
    @filterDialogOpen="getOrderOptions"
  >
    <template #form>
      <v-form ref="orderObjectForm">
        <v-row class="ma-0">
          <v-col cols="12">
            <SelectField
              v-model="saleOrderFilters.status"
              :itemsList="orderStatus"
              :multiple="true"
              label="select status"
              item-text="label"
              item-value="value"
              :dense="true"
              @change="saleOrderFiltersChanged('status', $event)"
            />
          </v-col>
          <v-row class="ma-0">
            <v-col cols="12">
              <span
                class="text-subtitle-1 font-weight-bold text-grey text-capitalize"
              >
                filter by Warning
              </span>
            </v-col>
            <v-col cols="12" lg="6" class="d-flex align-center">
              <v-select
                hide-details="auto"
                clearable
                outlined
                dense
                label="Has Warning"
                :items="binaryChoice"
                item-text="label"
                item-value="value"
                :value="saleOrderFilters.has_warning"
                :menu-props="{ offsetY: true }"
                @change="saleOrderFiltersChanged('has_warning', $event)"
              ></v-select>
            </v-col>
            <v-col cols="12" lg="6" class="d-flex align-center">
              <v-select
                hide-details="auto"
                clearable
                v-if="saleOrderFilters.has_warning"
                outlined
                dense
                label="select Warning"
                :items="warningType"
                item-text="display_value"
                item-value="value"
                :value="saleOrderFilters.warning_code"
                :menu-props="{ offsetY: true }"
                @change="saleOrderFiltersChanged('warning_code', $event)"
              ></v-select>
            </v-col>
          </v-row>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12">
            <span
              class="text-subtitle-1 font-weight-bold text-grey text-capitalize"
            >
              filter by date range
            </span>
          </v-col>
          <v-col cols="12" lg="6" xl="6">
            <DatePicker
              :value="saleOrderFilters.from_date"
              type="date"
              label="start date"
              outlined
              dense
              clearable
              @change="saleOrderFiltersChanged('from_date', $event)"
            ></DatePicker>
          </v-col>
          <v-col cols="12" lg="6" xl="6">
            <DatePicker
              :value="saleOrderFilters.to_date"
              type="date"
              label="end date"
              outlined
              dense
              clearable
              @change="saleOrderFiltersChanged('to_date', $event)"
            ></DatePicker>
          </v-col>
          <v-col cols="12">
            <SelectField
              clearable
              hide-details="auto"
              outlined
              dense
              label="sort by"
              :itemsList="sortBy"
              item-text="text"
              item-value="value"
              :value="saleOrderFilters.ordering"
              @change="saleOrderFiltersChanged('ordering', $event)"
            ></SelectField>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFilter>
</template>

<script>
import { bus } from "@/main";
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { mapState } from "vuex";
export default {
  components: {
    BaseFilter,
  },
  props: {
    value: Boolean,
    isChips: Boolean,
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      binaryChoice: [
        { label: "Yes", value: true },
        {
          label: "No",
          value: false,
        },
      ],
      orderStatus: [
        {
          label: "Unassigned",
          value: "unassigned",
        },
        {
          label: "Assigned",
          value: "assigned",
        },
        {
          label: "Picked Up",
          value: "pickedup",
        },
        {
          label: "Not Picked Up",
          value: "not_pickedup",
        },
        {
          label: "Partially Delivered",
          value: "partially_delivered",
        },
        {
          label: "Delivered",
          value: "delivered",
        },
        {
          label: "Not Delivered",
          value: "not_delivered",
        },
        {
          label: "Out For Delivery",
          value: "enroute",
        },
        {
          label: "Cancelled",
          value: "cancelled",
        },
      ],
      sortBy: [
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Status (Descending)",
          value: "-status",
        },
        {
          text: "Weight",
          value: "total_weight",
        },
        {
          text: "Weight (Descending)",
          value: "-total_weight",
        },
        {
          text: "Volume",
          value: "total_volume",
        },
        {
          text: "Volume (Descending)",
          value: "-total_volume",
        },
        {
          text: "Reference Number",
          value: "reference_number",
        },
        {
          text: "Reference Number (Descending)",
          value: "-reference_number",
        },
        {
          text: "Customer Name",
          value: "customer_name",
        },
        {
          text: "Customer Name (Descending)",
          value: "-customer_name",
        },
        {
          text: "Order Date",
          value: "execution_date",
        },
        {
          text: "Order Date (Descending)",
          value: "-execution_date",
        },
      ],
      orderBy: [
        {
          title: "Ascending",
          value: "ascending",
        },
        { title: "Descending", value: "descending" },
      ],
    };
  },
  methods: {
    getOrderOptions() {
      bus.$emit("showLoader", true);
      this.$api.order
        .getOrderOptions({ request_type: "filter" })
        .then((res) => {
          this.statusTypes = res?.data?.status;
          this.warningType = res?.data?.warning_code;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    saleOrderFiltersChanged(key, value) {
      let obj = {};
      obj[key] = value;
      this.$store.commit("userProfile/setFilters", {
        moduleKey: "sale_order_filters",
        payload: obj,
      });
    },
  },
  computed: {
    ...mapState("userProfile", {
      saleOrderFilters: (state) => state.sale_order_filters,
    }),
  },
};
</script>
